// All ETERNITY film copy lives here — edit this file to change what the site says.
export const ETERNITY = {
    title: 'ETERNITY',
    director: 'Maximus Barbare',
    // Public hook — used on the home + film heroes and share cards.
    hook: 'Do you want to live forever?',
    // Longer logline — reserved for festival / press materials.
    logline: "He had eternity to remember her. It wasn't enough.",
    status: 'In Production',
    release: '2028',
    statusLine: 'In Production — Coming 2028',
    synopsis:
        'In ETERNITY, an immortal man can’t escape the memory of the love he left behind, ' +
        'and discovers that forever is just long enough to forget. A twisted love story at its core, ' +
        'this story offers an engaging blend of romance, cyberpunk, and science fiction, telling a story that ' +
        'spans centuries.',
    specs: {
        runtime: '10–15 minutes',
        format: 'Animated short film',
        genre: 'Cyberpunk drama',
        year: '2028',
        studio: 'Maximum Productions',
    },
    directorsStatement:
        'ETERNITY started with a simple question: if you could keep a memory ' +
        'perfectly, forever, would it still be yours? We are building a city of ' +
        'neon and rain to ask it — a world where nothing is allowed to end, told ' +
        'through one man who needs something to. Animation is the only medium ' +
        'where memory and reality can dissolve into each other in a single frame, ' +
        'and we intend to use every frame.',
    // Easter egg (Cyberpunk 2077 thumbprint homage): flashes through the title
    // on the 5th click. Swap to a character name when dossiers ship.
    memory: 'Do you remember her?',
    // Hidden references (Blade Runner / Matrix). All editable here.
    eggs: {
        // Blade Runner — surfaces after a long idle on /eternity
        tearsInRain: [
            'I’ve seen things you people wouldn’t believe.',
            'All those moments will be lost in time…',
            'like tears in rain.',
        ],
        // Matrix — type "wake up"
        wakeUp: ['Wake up.', 'The film has you.', 'Follow the white rabbit.'],
        // type "forever"
        forever: 'Nobody lives forever. He keeps trying anyway.',
        // Obsession (2026) — type "obsession". The monkey's-paw wish for
        // undying love; ends only when one of them dies. Tagline last.
        obsession: [
            'More than ... anyone in the world?',
            'Be careful who you wish for.',
        ],
        // red / blue pill on the secret /remember page
        pillPrompt: 'This is your last chance. After this, there is no turning back.',
        pillRed: 'You stay — and watch him spend eternity trying to remember her.',
        pillBlue: 'The story ends. You wake up and believe whatever you want to believe.',
        rememberLine: 'She was real. He was sure of it. Almost.',
    },
    patreonContext: 'Keep it independent. Follow every step of production.',
    makingOfTagline:
        "We're building this from scratch; no budget, no experience. Everything gets filmed.",
    // Voice: confident with edge
    statement: "A short film about living forever. It's not a happy one.",
    signupHeading: 'Be first.',
    signupSub: 'One email when ETERNITY releases. Okay fine, maybe two. That’s probably it though.',
};
